import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCitiesLoading = (isLoading) => {
  return {
    type: actionTypes.SET_CITIES_LOADING,
    payload: isLoading
  }
}
